export const BLOG_HOME_PAGE = '/blog';
export const HOME_PAGE_NAME = 'home';

export const UP_NEXT_ARTICLE_MAP: Record<string, string> = {
    '7baaabece8e9461d895840c9b5155581': '243a67436797405fbc06af6dbaa8a1b1',
    '81f43306f03a47b2b4d54e6298de654f': '243a67436797405fbc06af6dbaa8a1b1',
    '94cfe68f54e74b4999c1a51faee65fcc': '243a67436797405fbc06af6dbaa8a1b1',
};